import { bindCollectionEvents, initializeCollections } from './glue/collections';
import { applyBootstrapData, fetchCollections, getBootstrapCollections, getFetchPlan, loadBrowserLang, loadUrlParams, scheduleBackgroundWork, showSitesTree } from './glue/startup';

(function() { // http://ricostacruz.com/backbone-patterns/#file_naming - The setup/glue code file
    initializeCollections();
    bindCollectionEvents();

    // Start the application, after everything is defined
    WiseMetering.start();

    const goToLogin = () => {
        if (Backbone.history.location.pathname !== '/login') {
            WiseMetering.targetUrl = Backbone.history.location.pathname;
        }

        Backbone.history.navigate('/login');
        Backbone.history.loadUrl(Backbone.history.fragment);
    };

    WiseMetering.startApp = () => {
        $.when($.get('/users/me'))
            .done(loginData => {
                const preferences = loginData.preferences;
                delete loginData.preferences;

                WiseMetering.currentUser = new WiseMetering.Model.User(loginData);
                WiseMetering.userPreferences = new WiseMetering.Model.UserPreference(preferences);

                WiseMetering.loadLang(WiseMetering.userPreferences.language());

                WiseMetering.setOrganization();
                WiseMetering.currentOrganization.fetch({ async: false });

                // Load plans data synchronously from the bootstrap
                WiseMetering.plans.loadFromBootstrap();

                Backbone.history.stop();
                Backbone.history.start({ pushState: true, root: `/${WiseMetering.currentOrganization.get('subdomain')}/`, silent: true });

                document.title = 'WiseMetering ' + WiseMetering.currentOrganization.get('name');
                WiseMetering.layout = new WiseMetering.Views.Layouts.Root({ model: WiseMetering.currentUser });
                WiseMetering.mainRegion.show(WiseMetering.layout);

                new WiseMetering.Views.Loading(); // Place the loader

                (async () => {
                // We only need the first position of the array
                    let [bootstrapData] = await Promise.all([
                        $.get(`/bootstrap?organization_id=${WiseMetering.currentOrganization.id}`),
                        WiseMetering.circuitTags.fetch(),
                        WiseMetering.circuits.fetch(),
                        WiseMetering.contracts.fetch(),
                        WiseMetering.folders.fetch(),
                        WiseMetering.indicators.fetch(),
                        WiseMetering.seus.fetch(),
                        WiseMetering.users.fetch(),
                        WiseMetering.utilities.fetch(),
                        WiseMetering.zones.fetch()
                    ]);

                    applyBootstrapData(bootstrapData);
                    showSitesTree();

                    const collections = getBootstrapCollections();
                    const { initialCollections, backgroundCollections, waitForDashboardEvents } = getFetchPlan(collections);

                    await fetchCollections(initialCollections);

                    if (waitForDashboardEvents) {
                        await WiseMetering.dashboardEvents.fetch({ data: { limit: 25 } });
                    }

                    // Load params that are relevant
                    loadUrlParams();
                    MapService.init();

                    // Load APP
                    WiseMetering.modalBox.close();

                    Backbone.history.loadUrl(Backbone.history.fragment);

                    // On ESC, either close the modal box or the main view
                    $('body').keyup(WiseMetering.onCancel);

                    if (!Backbone.history.fragment && WiseMetering.zones.sites().length === 1) {
                        Backbone.history.navigate(WiseMetering.zones.sites().first().nodeUrl(), { trigger: true });
                    }

                    WiseMetering.notifications.fetch();
                    setInterval(() => WiseMetering.notifications.fetch(), 60000);

                    scheduleBackgroundWork(async () => {
                        const backgroundRequests = backgroundCollections.map(collection => Promise.resolve(collection.fetch()));

                        if (!waitForDashboardEvents) {
                            backgroundRequests.push(Promise.resolve(WiseMetering.dashboardEvents.fetch({ data: { limit: 25 } })));
                        }

                        await Promise.allSettled(backgroundRequests);
                    });

                    // Bind stuff
                    WiseMetering.actuators.each(v => v.bindChange());
                    WiseMetering.indicators.each(v => v.bindChange());
                    WiseMetering.zone_attribute_values.each(v => v.bindChange());
                })();
            })
            .fail(goToLogin);
    };

    if (!WiseMetering.currentUser) {
        loadBrowserLang();
    }

    if (window.location.pathname === '/login') {
        goToLogin();
    } else if (window.location.pathname === '/design_system') {
        Backbone.history.navigate('/design_system');
        Backbone.history.loadUrl(Backbone.history.fragment);
    } else if (window.location.pathname === '/signup') {
        Backbone.history.navigate('/signup');
        Backbone.history.loadUrl(Backbone.history.fragment);
    } else if (window.location.pathname.startsWith('/reset_password')) {
        const id = window.location.pathname.split('/').pop() || 'code';
        Backbone.history.navigate(`/reset_password/${id}`);
        Backbone.history.loadUrl(Backbone.history.fragment);
    } else {
        WiseMetering.startApp();
    }
})();
